import { useRef, useEffect, useState } from 'react';

const galleryItems = [
  { id: 1,  src: 'https://i.postimg.cc/fbHcPdM3/1.png',        title: 'Concrete Patio Installation',     category: 'Hardscape' },
  { id: 2,  src: 'https://i.postimg.cc/xCcvVddf/2.png',        title: 'Front Yard Transformation',       category: 'Landscaping' },
  { id: 3,  src: 'https://i.postimg.cc/SsJ6bKKK/3.png',        title: 'Desert Garden Design',            category: 'Landscaping' },
  { id: 4,  src: 'https://i.postimg.cc/gJnVb00n/4.png',        title: 'Raised Planter Beds',             category: 'Hardscape' },
  { id: 5,  src: 'https://i.postimg.cc/0QbY1NNY/5.png',        title: 'Garden Pathway & Planting',       category: 'Landscaping' },
  { id: 6,  src: 'https://i.postimg.cc/ftQtxDmL/6-after.png',  title: 'Front Yard — After',              category: 'Before & After' },
  { id: 7,  src: 'https://i.postimg.cc/0M1MpPDr/6-before.png', title: 'Front Yard — Before',             category: 'Before & After' },
  { id: 8,  src: 'https://i.postimg.cc/yghJjtyN/7.png',        title: 'Curb Appeal Upgrade',             category: 'Landscaping' },
  { id: 9,  src: 'https://i.postimg.cc/k6NVszv4/8.png',        title: 'Entry Steps & Planters',          category: 'Hardscape' },
  { id: 10, src: 'https://i.postimg.cc/YGN4RZzj/9.png',        title: 'Lush Backyard Greenery',          category: 'Landscaping' },
  { id: 11, src: 'https://i.postimg.cc/Fdbfp8VY/10.png',       title: 'Stairway & Entry Design',         category: 'Hardscape' },
  { id: 12, src: 'https://i.postimg.cc/pytzjYJf/11.png',       title: 'Arched Entry Landscaping',        category: 'Landscaping' },
  { id: 13, src: 'https://i.postimg.cc/VdftGfTJ/12.png',       title: 'Courtyard Paver Design',          category: 'Hardscape' },
  { id: 14, src: 'https://i.postimg.cc/rKV4nVbK/13.png',       title: 'Tropical Front Garden',           category: 'Landscaping' },
  { id: 15, src: 'https://i.postimg.cc/6yWZjWSq/14.png',       title: 'Gravel Driveway & Grading',       category: 'Grading' },
  { id: 16, src: 'https://i.postimg.cc/MKRYGXm0/15.png',       title: 'Site Preparation & Excavation',   category: 'Grading' },
  { id: 17, src: 'https://i.postimg.cc/rpyGgjXC/16.png',       title: 'Lawn & Landscape Renovation',     category: 'Landscaping' },
  { id: 18, src: 'https://i.postimg.cc/tsfV4hgn/17.png',       title: 'Stone Pathway & Planting',        category: 'Hardscape' },
  { id: 19, src: 'https://i.postimg.cc/bvY0LgcR/18.png',       title: 'Flagstone Courtyard',             category: 'Hardscape' },
  { id: 20, src: 'https://i.postimg.cc/dhXTV80k/19.png',       title: 'Succulent Garden Design',         category: 'Landscaping' },
  { id: 21, src: 'https://i.postimg.cc/Mn4jpyGd/20.png',       title: 'New Construction Grading',        category: 'Grading' },
  { id: 22, src: 'https://i.postimg.cc/qNYCv871/21.png',       title: 'Lot Clearing & Prep',             category: 'Grading' },
  { id: 23, src: 'https://i.postimg.cc/WDkqFhDg/23.png',       title: 'Brick Fire Pit Area',             category: 'Hardscape' },
  { id: 24, src: 'https://i.postimg.cc/2qZLbVqx/24.png',       title: 'Rock Garden & Mulch Bed',         category: 'Landscaping' },
  { id: 25, src: 'https://i.postimg.cc/rdrR0KdJ/25.png',       title: 'Curved Driveway Edging',          category: 'Hardscape' },
  { id: 26, src: 'https://i.postimg.cc/bGtSDsGm/26.png',       title: 'Backyard Lawn Renovation',        category: 'Landscaping' },
  { id: 27, src: 'https://i.postimg.cc/gwZLXnwM/27.png',       title: 'Patio & Fence Installation',      category: 'Hardscape' },
  { id: 28, src: 'https://i.postimg.cc/HJy8cVJv/28.png',       title: 'Deck & Outdoor Space',            category: 'Hardscape' },
  { id: 29, src: 'https://i.postimg.cc/7C2JGfCc/29.png',       title: 'Stepping Stone Path',             category: 'Hardscape' },
  { id: 30, src: 'https://i.postimg.cc/d7yZkLkY/30.png',       title: 'Palm Tree Landscaping',           category: 'Landscaping' },
  { id: 31, src: 'https://i.postimg.cc/3yv04d4h/31.png',       title: 'Driveway & Entry Pavers',         category: 'Hardscape' },
];

const categories = ['All', 'Hardscape', 'Landscaping', 'Before & After', 'Grading'];

const GallerySection = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const [activeCategory, setActiveCategory] = useState('All');
  const [lightbox, setLightbox] = useState<number | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setLightbox(null);
      if (e.key === 'ArrowRight' && lightbox !== null) {
        const filtered = activeCategory === 'All' ? galleryItems : galleryItems.filter(i => i.category === activeCategory);
        const idx = filtered.findIndex(i => i.id === lightbox);
        if (idx < filtered.length - 1) setLightbox(filtered[idx + 1].id);
      }
      if (e.key === 'ArrowLeft' && lightbox !== null) {
        const filtered = activeCategory === 'All' ? galleryItems : galleryItems.filter(i => i.category === activeCategory);
        const idx = filtered.findIndex(i => i.id === lightbox);
        if (idx > 0) setLightbox(filtered[idx - 1].id);
      }
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [lightbox, activeCategory]);

  const filtered = activeCategory === 'All' ? galleryItems : galleryItems.filter(i => i.category === activeCategory);
  const lightboxItem = galleryItems.find(i => i.id === lightbox);
  const lightboxFiltered = activeCategory === 'All' ? galleryItems : galleryItems.filter(i => i.category === activeCategory);
  const lightboxIdx = lightboxFiltered.findIndex(i => i.id === lightbox);

  return (
    <section id="gallery" ref={ref} className="py-20 md:py-28 bg-brand-cream">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">

        {/* Header */}
        <div className={`flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 border border-brand-amber/40 rounded-full mb-4">
              <span className="text-xs font-semibold text-brand-amber uppercase tracking-widest">Our Work</span>
            </div>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-brand-dark">
              Real Projects,{' '}
              <span className="text-brand-amber italic">Real Results</span>
            </h2>
          </div>
          <p className="text-brand-stone text-base max-w-sm">
            Browse our completed landscaping and hardscape projects — every photo is from an actual job we've done.
          </p>
        </div>

        {/* Filter Tabs */}
        <div className={`flex flex-wrap gap-2 mb-8 transition-all duration-700 delay-100 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          {categories.map(cat => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 ${
                activeCategory === cat
                  ? 'bg-brand-amber text-white'
                  : 'bg-white text-brand-stone border border-brand-stone/20 hover:border-brand-amber hover:text-brand-amber'
              }`}
            >
              {cat}
            </button>
          ))}
          <span className="ml-auto text-brand-stone/50 text-sm self-center">{filtered.length} photos</span>
        </div>

        {/* Gallery Grid */}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
          {filtered.map((item, idx) => (
            <div
              key={item.id}
              className={`break-inside-avoid group relative overflow-hidden rounded-xl cursor-pointer transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${Math.min(idx * 60, 500)}ms` }}
              onClick={() => setLightbox(item.id)}
            >
              <img
                src={item.src}
                alt={item.title}
                className="w-full h-auto object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                <span className="inline-block px-2 py-0.5 bg-brand-amber rounded text-white text-xs font-semibold mb-1">{item.category}</span>
                <p className="text-white text-sm font-medium">{item.title}</p>
              </div>
              <div className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-zoom-in-line text-white text-sm" />
              </div>
            </div>
          ))}
        </div>

      </div>

      {/* Lightbox */}
      {lightbox !== null && lightboxItem && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={() => setLightbox(null)}
        >
          <button
            className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white cursor-pointer transition-colors"
            onClick={() => setLightbox(null)}
          >
            <i className="ri-close-line text-xl" />
          </button>

          {/* Prev */}
          {lightboxIdx > 0 && (
            <button
              className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white cursor-pointer transition-colors"
              onClick={e => { e.stopPropagation(); setLightbox(lightboxFiltered[lightboxIdx - 1].id); }}
            >
              <i className="ri-arrow-left-s-line text-xl" />
            </button>
          )}

          {/* Next */}
          {lightboxIdx < lightboxFiltered.length - 1 && (
            <button
              className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white cursor-pointer transition-colors"
              onClick={e => { e.stopPropagation(); setLightbox(lightboxFiltered[lightboxIdx + 1].id); }}
            >
              <i className="ri-arrow-right-s-line text-xl" />
            </button>
          )}

          <div className="max-w-4xl w-full" onClick={e => e.stopPropagation()}>
            <img
              src={lightboxItem.src}
              alt={lightboxItem.title}
              className="w-full max-h-[80vh] object-contain rounded-xl"
            />
            <div className="mt-3 text-center">
              <span className="inline-block px-2 py-0.5 bg-brand-amber rounded text-white text-xs font-semibold mr-2">{lightboxItem.category}</span>
              <span className="text-white/80 text-sm">{lightboxItem.title}</span>
              <span className="text-white/40 text-xs ml-3">{lightboxIdx + 1} / {lightboxFiltered.length}</span>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default GallerySection;
